import './App.css';
import About from './components/About';
import { BrowserRouter as Router, Route, Link, Routes }
  from "react-router-dom";
import Home from './components/Home';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Project from './components/Project';
import News from './components/News';
import Shop from './components/Shop';
import Career from './components/Career';
import Accessories from './components/Shop/Yokogawa/Accessories';
import Oscilloscopes from './components/Shop/Rohde & Schwarz/Oscilloscopes';
import Broadban from './components/Shop/Rohde & Schwarz/Broadban';
import EMCtestSystem from './components/Shop/Rohde & Schwarz/EMCtestSystem';
import EMCtestReceivers from './components/Shop/Rohde & Schwarz/EMCtestReceivers';
import DL5000 from './components/Shop/Yokogawa/mixed_signal/dl5000';
import DLM3000 from './components/Shop/Yokogawa/mixed_signal/dlm3000';
import DL950 from './components/Shop/Yokogawa/scopecorder/DL950';
import DL350 from './components/Shop/Yokogawa/scopecorder/DL350';
import WT5000 from './components/Shop/Yokogawa/power_analyser/WT5000';
import WT1800E from './components/Shop/Yokogawa/power_analyser/WT1800E';
import WT300E from './components/Shop/Yokogawa/power_analyser/WT300E.js';
import DigitalMultimeter from './components/Shop/Yokogawa/handHeld_instrument/digitalMultimeter.js';
import CA500 from './components/Shop/Yokogawa/handHeld_instrument/CA500.js';
import ClampOntester from './components/Shop/Yokogawa/handHeld_instrument/ClampOntester.js';
import MY600 from './components/Shop/Yokogawa/handHeld_instrument/MY600.js';
import EOLTestHrdwareSetup from './components/Shop/EOL_TestSystem/EOLTestHrdwareSetup.js';
import EOLtesting from './components/Shop/EOL_Testing/EOLtesting.js';
import DLDCconverter from './components/Shop/EOL_Testing/DLDC-converter.js';
import OffBoardElectricCharger from './components/Shop/EOL_Testing/OffBoardElectricCharger.js';
import EOLEVMotors from './components/Shop/EOL_Testing/EOLEVMotors.js';
import PLC from './components/Shop/Automation_solution/Industrial_solution/PLC.js';
import SCADA from './components/Shop/Automation_solution/SCADA.js';
import HMI from './components/Shop/Automation_solution/Industrial_solution/HMI.js';
import ControlSystem from './components/Shop/Automation_solution/process_solution/ControlSystem.js';
import Sensor from './components/Shop/Automation_solution/process_solution/Sensor.js';
import Robotics from './components/Shop/Automation_solution/process_solution/Robotics.js';
import LabView from './components/Shop/Automation_solution/process_solution/LabView.js';
import HVAC from './components/Shop/Automation_solution/Building_solution/HVAC.js';
import Lighting from './components/Shop/Automation_solution/Building_solution/Lighting.js';
import Security from './components/Shop/Automation_solution/Building_solution/Security.js';
import Humidity from './components/Shop/Chambers/Humidity.js';
import Laminar from './components/Shop/Chambers/Laminar.js';
import Walking from './components/Shop/Chambers/Walking.js';
import Minus60 from './components/Shop/Chambers/Minus60.js';
import BlastFreezer from './components/Shop/Chambers/BlastFreezer.js';
import AntistaticWorkbench from './components/Shop/ESD_Labsetup/AntistaticWorkbench.js';
import ESDPCBRack from './components/Shop/ESD_Labsetup/ESDPCBRack.js';
import ESDSafe from './components/Shop/ESD_Labsetup/ESDSafe.js';
import ESDSafeBin from './components/Shop/ESD_Labsetup/ESDSafeBin.js';
import GroundingChord from './components/Shop/ESD_Labsetup/GroundingChord.js';
import ESDSafeMatting from './components/Shop/ESD_Labsetup/ESDSafeMatting.js';
import HotwaterTank from './components/projects/hotwaterTank.js';
import ColdwaterTank from './components/projects/ColdwaterTank.js';
import CompositeTester from './components/projects/CompositeTester.js';
import VaccumChamber from './components/projects/VaccumChamber.js';
import CustomizedCompositeTest from './components/projects/CustomizedCompositeTest.js';
import EOLtestSandhar from './components/projects/EOLtestSandhar.js';
import EOLoffboard from './components/projects/EOLoffboard.js';
import EOLforMotorController from './components/projects/EOLforMotorcontroller.js';

function App() {
  return (
    <div className="">

      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          {/* <Route exact path="/projects" element={<Project />} /> */}
          <Route exact path="/products" element={<Shop />} />
          <Route exact path="/contactUs" element={<Contact />} />
          <Route exact path="/aboutUs" element={<About />} />
          <Route exact path="/news" element={<News />} />
          <Route exact path="/career" element={<Career />} />
          <Route exact path="/DLM5000" element={<DL5000 />} />
          <Route exact path="/DLM3000" element={<DLM3000 />} />
          <Route exact path="/DL950" element={<DL950 />} />
          <Route exact path="/DL350" element={<DL350 />} />
          <Route exact path="/WT5000" element={<WT5000 />} />
          <Route exact path="/WT1800E" element={<WT1800E />} />
          <Route exact path="/WT300E" element={<WT300E />} />
          <Route exact path="/DigitalMultimeters" element={<DigitalMultimeter />} />
          <Route exact path="/CA500series" element={<CA500 />} />
          <Route exact path="/ClampOnTesters" element={<ClampOntester />} />
          <Route exact path="/MY600DigitalInsulationTester" element={<MY600 />} />
          <Route exact path="/Accessories" element={<Accessories />} />
          <Route exact path="/Oscilloscopes" element={<Oscilloscopes />} />
          <Route exact path="/broadband_amplifier" element={<Broadban />} />
          <Route exact path="/EMC_test_system" element={<EMCtestSystem />} />
          <Route exact path="/EMC_test_receivers" element={<EMCtestReceivers />} />
          <Route exact path="/EOL-test-hardware-setup" element={<EOLTestHrdwareSetup />} />
          <Route exact path="/EOL-for-DLDC-coverter" element={<DLDCconverter />} />
          <Route exact path="/EOL-for-off-board-charger" element={<OffBoardElectricCharger />} />
          <Route exact path="/EOL-for-MCU" element={<EOLEVMotors />} />
          <Route exact path="/EOL-Testing" element={<EOLtesting />} />
          <Route exact path="/PLC" element={<PLC />} />
          <Route exact path="/SCADA" element={<SCADA />} />
          <Route exact path="/HMI" element={<HMI />} />
          <Route exact path="/control-system" element={<ControlSystem />} />
          <Route exact path="/sensor&actuator" element={<Sensor />} />
          <Route exact path="/robotics" element={<Robotics />} />
          <Route exact path="/labview" element={<LabView />} />
          <Route exact path="/HVAC-Control-system" element={<HVAC />} />
          <Route exact path="/lighting-control" element={<Lighting />} />
          <Route exact path="/security-system" element={<Security />} />
          <Route exact path="/humidity-stability-chamber" element={<Humidity />} />
          <Route exact path="/laminar-air-flow" element={<Laminar />} />
          <Route exact path="/walking-plant-growth-chamber" element={<Walking />} />
          <Route exact path="/minus-60-deep-freezer" element={<Minus60 />} />
          <Route exact path="/blast-freezer" element={<BlastFreezer />} />
          <Route exact path="/antistatic-workbench" element={<AntistaticWorkbench />} />
          <Route exact path="/ESD-PCB-Rack" element={<ESDPCBRack />} />
          <Route exact path="/ESD-Safe-Conveyor" element={<ESDSafe />} />
          <Route exact path="/ESD-Safe-Bin" element={<ESDSafeBin />} />
          <Route exact path="/Grounding-Chord" element={<GroundingChord />} />
          <Route exact path="/ESD-Safe-Matting" element={<ESDSafeMatting />} />
          <Route exact path="/hot-water-tank-for-LG" element={<HotwaterTank />} />
          <Route exact path="/cold-water-tank-for-LG" element={<ColdwaterTank />} />
          <Route exact path="/composite-tester-for-LG" element={<CompositeTester />} />
          <Route exact path="/vacuum-chamber" element={<VaccumChamber />} />
          {/* <Route exact path="/projects/EOL-DC-DC-Converter" element={<CustomizedCompositeTest />} /> */}
          <Route exact path="/Sandhar-Auto-Electric–DC-DC-Converter" element={<EOLtestSandhar />} />
          <Route exact path="/Off-Board-Electric-Vehicle-(EV)-Chargers" element={<EOLoffboard />} />
          <Route exact path="/EOL-for-Motor-Controller-Unit" element={<EOLforMotorController />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
